import React, { useState, useEffect, useCallback } from 'react'
import { Template } from '../../Components/Template/template'
import { Link, useNavigate } from 'react-router-dom'
import {
    AlertType, Cidade, CidadeEstadoAttributes, Clientes, Estado, classBorderLabelDark, classBt, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo,
    classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, classbtAzul, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classbtVerde
} from '../../Utils/Types'
import { Icone } from '../../Components/Icones/Index'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { IoSearch, IoAddCircleSharp, IoPrint, IoCloseCircleOutline } from 'react-icons/io5'
import { ClientesService } from './ClientesService'
import { GridCliente } from '../../Components/GridProducts/GridCliente'
import { FaTrash, FaVideo } from 'react-icons/fa'
import { ReportClientesPDF } from './pdf/report-clientes'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { UtilServices } from '../../Utils/UtilServices'
import { Tooltip } from 'react-tooltip'
import { AiOutlineClear } from 'react-icons/ai'
import { Funcoes } from '../../Utils/Funcoes'
import { FaUserGroup } from 'react-icons/fa6'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

export const ClientesPage = () => {

    // sem uso
    /*
    //const [searchBoxResponsivo, setSearchBoxResponsivo] = useState<boolean>(false)
    //const [btImpDisabled, //setbtImpDisabled] = useState<boolean>(false)  
    */

    // ---------- ATRIBUTOS FEEDBACK -----------------------------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO -------------------------------------
    const [field, setField] = useState('nome')
    const [filterType, setFilterType] = useState('start')
    const [filter, setFilter] = useState('')


    // ---------- ATRIBUTOS FILTRO AVANÇADO ----------------------------
    const [datai, setDatai] = useState("")
    const [dataf, setDataf] = useState("")
    const [tipoPessoa, setTipoPessoa] = useState("")
    const [ativo, setAtivo] = useState("")

    const [idUf, setIdUf] = useState(0)
    const [uf, setUf] = useState<Estado[]>([])
    const [siglaUf, setSiglaUf] = useState("")

    const [idCity, setIdCity] = useState(0)
    const [cidade, setCidade] = useState<Cidade[]>([])
    const [nomeCidade, setNomeCidade] = useState("")

    // ---------- ATRIBUTOS GRID ---------------------------------------
    const [clientes, setClientes] = useState<Clientes[]>([])
    const [attributes, setAttributes] = useState<CidadeEstadoAttributes>()

    // ---------- ATRIBUTOS SEARCHBOX ----------------------------------
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL ----------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getCliente = async () => {

        setLoading(true)

        try {

            const clientes = await ClientesService.Filter(field, filterType, filter)
            setClientes(clientes.data)

            const attr = await UtilServices.GetCidadeEstado()

            if (attr) {
                setAttributes(attr.data)
                setUf(attr.data.estados)
                //setCidade(attr.cidades)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar as informações`)

            setClientes([])

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroCli") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxUF && !visibleSearchBoxCity && !loading && menuFiltro.classList.contains("max-h-[1000px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [filter, filterType, field, datai, dataf, tipoPessoa, ativo, idCity, siglaUf, visibleSearchBoxUF, visibleSearchBoxCity, loading])

    useEffect(() => {
        getCliente()
    }, [])

    const inputFocus = () => {
        const inputElement = document.getElementById("pesquisa_cliente")
        inputElement?.focus()
    }

    const inputDesfocus = () => {
        const inputElement = document.getElementById("pesquisa_cliente")
        inputElement?.blur()
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxUF(false)
        setVisibleSearchBoxCity(false)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleChangeField = (e: React.ChangeEvent<HTMLSelectElement>) => {

        const fieldMap: { [key: string]: string } = {
            'nome': 'nome',
            'nome_fantasia': 'nome_fantasia',
            'cnpj_cpf': 'cnpj_cpf',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setField(selectedField)
            inputFocus()
        }
    }

    const handleFilterTypeChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const filterMap: { [key: string]: string } = {
            'start': 'start',
            'equals': 'equals',
            'contains': 'contains',
        }

        const selectedFilter = filterMap[e.target.value]

        if (selectedFilter) {
            setFilterType(selectedFilter)
            inputFocus()
        }
    }

    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (field === 'cnpj_cpf') {

            const value = e.target.value.replace(/[^0-9]/g, '')
            const numericValue = Funcoes.onlyNumber(value.replace(/[./-]/g, ''))

            setFilter(value)

            if (numericValue.length === 11 || numericValue.length === 14) {
                const formattedDoc = Funcoes.FormatDoc(numericValue)
                setFilter(formattedDoc || value)
            }

        } else {
            setFilter(e.target.value)
        }
    }

    useEffect(() => {

        if (field === 'cnpj_cpf') {

            setFilter(filter.replace(/[^0-9]/g, '').slice(0, 14))
            const numericValue = Funcoes.onlyNumber(filter.replace(/[./-]/g, '').slice(0, 14))

            if (numericValue.length === 11 || numericValue.length === 14) {
                const formattedDoc = Funcoes.FormatDoc(numericValue)
                setFilter(formattedDoc || filter)
            }

        }

    }, [field])

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setClientes([])
        searchBoxFocus()
        inputDesfocus()

        try {

            const relatorio = {
                dt_cad_ini: datai,
                dt_cad_fim: dataf,
                tipo_pessoa: tipoPessoa,
                status: ativo,
                uf: siglaUf,
                id_cidade: idCity,
            }

            const clientes = await ClientesService.Filter(field, filterType, filter.replace(/[./-]/g, ''), relatorio)

            if (clientes.error) {
                setVisible(true)
                setMessageType('DANGER')
                setMessage(clientes.msg || '')
            } else {
                setClientes(clientes.data)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os clientes`)

        } finally {

            const timer = setTimeout(() => {
                inputFocus()
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }

        //setbtImpDisabled(false)
    }

    const filterDados = useCallback(async () => {

        setVisible(false)

        try {

            const relatorio = {
                dt_cad_ini: datai,
                dt_cad_fim: dataf,
                tipo_pessoa: tipoPessoa,
                status: ativo,
                uf: siglaUf,
                id_cidade: idCity,
            }

            const clientes = await ClientesService.Filter(field, filterType, filter.replace(/[./-]/g, ''), relatorio)

            if (clientes.error) {
                setVisible(true)
                setMessageType('DANGER')
                setMessage(clientes.msg || '')
            } else {
                setClientes(clientes.data)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os clientes`)
            setClientes([])
        }

    }, [clientes, field, filterType, filter, datai, dataf, tipoPessoa, ativo, siglaUf, idCity])

    const limparCampoFilter = () => {
        setFilter("")
        inputFocus()
    }

    //------------------------------------------------------------------ PDF ----------------------------------------------------------------------------------------------//
    const handleGerarPDFClick = async (event: any) => {
        try {
            const header = [
                { text: 'Nome / Razão', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'CPF / CNPJ', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Cidade', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Data', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
            ]

            const pdf = new ReportClientesPDF(clientes, header, datai, dataf, tipoPessoa, ativo, siglaUf, nomeCidade)
            pdf.GerarPDF(clientes)

            event.currentTarget.blur()

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)
        }
    }

    //------------------------------------------------------------- FILTROS AVANÇADOS --------------------------------------------------------------------------------//
    const toggleMenuFiltro = (event: any) => {

        //let menuControl = document.getElementById("divMenuControlCli") as HTMLDivElement

        let menuFiltro = document.getElementById("divMenuFiltroCli") as HTMLDivElement
        let menuInputs = document.getElementById("divInputsCli") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            //menuControl.classList.toggle("rounded-md")
            //menuControl.classList.toggle("rounded-t-md")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                //menuControl.classList.remove("rounded-md")
                //menuControl.classList.add("rounded-t-md")
                //setSearchBoxResponsivo(true)

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 150)

            } else {

                //menuControl.classList.add("rounded-md")
                //menuControl.classList.remove("rounded-t-md")
                //setSearchBoxResponsivo(false)

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur()
        }
    }

    const handleLimparFiltros = () => {

        /*
        if (datai != '' || dataf != '' || tipoPessoa != '' || ativo != '' || idUf != 0 || idCity != 0) {
            //setbtImpDisabled(true)
        }
        */

        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)

        setFilter("")
        setDatai("")
        setDataf("")
        setTipoPessoa("")
        setAtivo("")
        setIdUf(0)
        setSiglaUf("")
        setIdCity(0)

        setNomeCidade("")

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        //searchBoxFocus()
        inputFocus()
    }

    /*
    const getFilterCliente = async () => {
         setLoading(true)
         const relatorio = {
             datai: datai,
             dataf: dataf,
             ativo: ativo,
             id_cidade: idCity,
             uf: siglaUf,
             fisica_juridica: tipoPessoa
         }
         const attr = await ClientesService.FilterRelatorio(relatorio)
         setClientes(attr)
         setLoading(false)
    }
    */

    const dataiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
        //setbtImpDisabled(true)
    }

    const datafChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
        //setbtImpDisabled(true)
    }

    const tipoPessoaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoPessoa(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    //------------------------------------------------------------- ESTADOS --------------------------------------------------------------------------------//
    const handleClearUfSelecionada = useCallback(() => {

        setIdUf(0)
        setSiglaUf("")

        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)

        setCidade([])
        setIdCity(0)

        setVisibleSearchBoxUF(false)

        //setbtImpDisabled(true)
        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */

    }, [attributes?.estados])

    const handleFilterUfClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            const newUfList = [...attributes?.estados || []]
            setUf(newUfList)

        } else {

            const newUfList = [...attributes?.estados || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }

    }, [attributes?.estados])

    const handleUfSelectClick = useCallback((v: Estado) => {

        if (v.id > 0) {

            setIdUf(v.id)
            setSiglaUf(v.sigla)
            setarCidades(v.sigla)

        } else {

            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)

        setIdCity(0)
        setNomeCidade('')

        setVisibleSearchBoxUF(false)

        //setbtImpDisabled(true)
    }, [attributes?.estados])

    const clickSearchBoxUF = useCallback(() => {
        setVisibleSearchBoxUF((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha outros search boxes e foca no UF
                setVisibleSearchBoxCity(false)
                inputFocusUF()
            }
            return newState
        })
    }, [])

    const inputFocusUF = () => {
        let inputSearch = document.getElementById(`inputSearchBox-uf`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------- CIDADES --------------------------------------------------------------------------------//
    const handleClearCidadeSelecionada = useCallback(() => {

        setIdCity(0)
        setNomeCidade('')
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)

        //setbtImpDisabled(true)

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */

    }, [attributes?.cidades, uf])

    const handleFilterCidadeClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            /*
            const newCidadeList = [...attributes?.cidades || []]
            setCidade(newCidadeList)
            */

            setarCidades(siglaUf)

        } else {

            const newCidadeList = [...attributes?.cidades || []].filter((item) => {

                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) && item.uf === siglaUf

                /*
                if (idUf > 0) {

                    return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) &&
                        item.uf === siglaUf

                } else {

                    return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
                }
                */
            })

            setCidade(newCidadeList || [])
        }
    }, [attributes?.cidades, uf])

    const handleCidadeSelectClick = useCallback((v: Cidade) => {

        if (v) {
            setIdCity(v.id)
            setNomeCidade(v.description)
            //setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)

        //setbtImpDisabled(true)

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.cidades, uf])

    const clickSearchBoxCidade = useCallback(() => {
        setVisibleSearchBoxCity((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxUF e foca no SearchBoxCity
                setVisibleSearchBoxUF(false)
                inputFocusCidade()
            }
            return newState
        })
    }, [])

    const inputFocusCidade = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cidade`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    const setarCidades = async (uf: string) => {
        const citys = attributes?.cidades.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    // ----------------------------------------------------------- NAVEGAÇÃO -------------------------------------------------------------------------------//
    const navigate = useNavigate()

    const navegarTelaCliente = () => {
        //navigate("/cliente/new")
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div id="div-body" role='button' className={`${classDivBody}`}>

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-8 sm:col-span-10 xl:col-span-5 flex flex-row items-center`}>
                            <FaUserGroup className={`mx-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Clientes</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`relative col-span-4 sm:col-span-2 xl:col-span-1`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/cliente/excluidos'} data-tooltip-id={'tooltip-btn-lixeira'} id={'btn-lixeira'} className={`${classbtColunasVermelho} h-9`} >

                                <FaTrash className={`mx-2`} size="25px" />

                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-btn-lixeira'} anchorSelect={'#btn-lixeira'} positionStrategy="fixed" place='left' >
                                    <span>Clientes Excluídos</span>
                                </Tooltip>

                            </Link>

                        </div>

                        <div className={`relative col-span-4 xl:col-span-2`}>

                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>

                        </div>

                        <div className={`relative col-span-4 xl:col-span-2`}>

                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(clientes.length > 0)} onClick={handleGerarPDFClick}>
                                <IoPrint size="20px" className={`mr-2 hidden md:block`} /> Imprimir
                            </button>

                        </div>

                        <div className={`relative col-span-4 xl:col-span-2`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/cliente/new'} className={`${classBtSemDuration} ${classbtVerde} h-9`} >
                                <IoAddCircleSharp className={`mx-2 hidden md:block`} size="20px" /> Cadastro
                            </Link>

                            {/*
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtVerde} h-9`} onClick={navegarTelaCliente}>
                                <IoAddCircleSharp size="20px" className={`mr-2 hidden md:block`} /> Cadastro
                            </button>
                            */}

                        </div>

                    </div>

                    <div id='divInputsCli' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroCli' className={`relative max-h-[0px] h-[850px] sm:h-[340px] 2xl:h-[270px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-7 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select id='filter_to' disabled={loading} className={`${classInput} ${classInputDark}`} value={field} onFocus={searchBoxFocus} onChange={handleChangeField} >
                                    <option value="nome">RAZÃO / NOME</option>
                                    <option value="nome_fantasia">NOME FANTASIA</option>
                                    <option value="cnpj_cpf">CPF / CNPJ</option>
                                </select>
                                <label htmlFor="filter_to" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}><Icone icon={faFilter} /><span className={`ml-2`}>Filtrar por</span></label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select id='filter_type' disabled={loading} className={`${classInput} ${classInputDark} `} value={filterType} onFocus={searchBoxFocus} onChange={handleFilterTypeChange}>
                                    <option value="start">INICIA COM</option>
                                    <option value="equals">IGUAL A</option>
                                    <option value="contains">CONTÉM</option>
                                </select>
                                <label htmlFor="filter_type" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Critério</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-6 xl:col-span-8 mt-3 sm:mt-0`}>
                                <input id="pesquisa_cliente" className={`${classInput} ${classInputDark} pr-10`} type="text" inputMode={field === 'cnpj_cpf' ? 'numeric' : 'text'} maxLength={field === 'cnpj_cpf' ? 18 : 999} placeholder=' ' autoComplete="off" value={filter} onFocus={searchBoxFocus} onChange={handleChangeFilter} />
                                <label htmlFor="pesquisa_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Digite sua consulta</label>
                                <button className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none ${filter === '' ? 'invisible' : 'visible'}`} onClick={limparCampoFilter} >
                                    <IoCloseCircleOutline size="25px" />
                                </button>
                            </div>

                            <div className={`relative col-span-12`}>
                                <span className={`text-[14px] text-slate-500 dark:text-slate-300`}>Filtros Avançados</span>
                                <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700 w-[100%] mt-2`} />
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <input id='data-inicial' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' autoComplete='off' value={datai} disabled={loading} onFocus={searchBoxFocus} onChange={dataiChange} />
                                <label htmlFor="data-inicial" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Cadastro Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <input id='data-final' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' autoComplete='off' value={dataf} disabled={loading} onFocus={searchBoxFocus} onChange={datafChange} />
                                <label htmlFor="data-final" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Cadastro Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-2 xl:col-span-1 2xl:col-span-1 mt-3`}>
                                <select id="tipoPessoa" className={`${classInput} ${classInputDark} ${tipoPessoa === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={tipoPessoa} onFocus={searchBoxFocus} onChange={tipoPessoaChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}> (selecione)</option>
                                    <option value="F" className={`text-slate-900 dark:text-slate-200`}>Física</option>
                                    <option value="J" className={`text-slate-900 dark:text-slate-200`}>Jurídica</option>
                                </select>
                                <label htmlFor="tipoPessoa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Pessoa</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-2 xl:col-span-1 2xl:col-span-1 mt-3`}>
                                <select id="ativo" className={`${classInput} ${classInputDark} ${ativo === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}>(selecione)</option>
                                    <option value="S" className={`text-slate-900 dark:text-slate-200`}>Sim</option>
                                    <option value="N" className={`text-slate-900 dark:text-slate-200`}>Não</option>
                                </select>
                                <label htmlFor="ativo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                            </div>

                            <div id='componenteEstado' className={`relative col-span-12 sm:col-span-4 xl:col-span-4 2xl:col-span-2 mt-3`}>
                                <SearchBox
                                    dataList={uf}
                                    idRegistro={idUf || undefined}
                                    label='Estado'
                                    componentId='uf'
                                    visibleTAB={visibleSearchBoxUF}
                                    clearDataClick={handleClearUfSelecionada}
                                    setDataClick={handleUfSelectClick}
                                    filterDataClick={handleFilterUfClick}
                                    clicado={clickSearchBoxUF}
                                />
                            </div>

                            <div id='componenteCidade' className={`relative col-span-12 sm:col-span-8 xl:col-span-6 2xl:col-span-4 mt-3`}>
                                <SearchBox
                                    dataList={cidade}
                                    idRegistro={idCity || undefined}
                                    label='Cidade'
                                    componentId='cidade'
                                    visibleTAB={visibleSearchBoxCity}
                                    clearDataClick={handleClearCidadeSelecionada}
                                    setDataClick={handleCidadeSelectClick}
                                    filterDataClick={handleFilterCidadeClick}
                                    clicado={clickSearchBoxCidade}
                                />
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className={`mx-1`}>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridCliente cliente={clientes} handleUpdateClienteList={filterDados} />
                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_cliente.mp4'
                            title='Como cadastrar um cliente'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>
    )
}